import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const TaskContent = styled("div")(() => ({
  backgroundColor: "#F9FAFB",
  padding: "1rem",
  borderRadius: 12,
}));

export const TimeControlWrapper = styled("div")(() => ({
  padding: "1rem 0",
}));

export const TimeControlTitle = styled("span")(() => ({
  color: "#465869",
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: "24px",
}));

export const GeneralWrapper = styled("div")(() => ({
  padding: "1rem 0 2rem 0",
}));

export const MultiDayTaskBadge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  backgroundColor: colors.brandBlue50,
  borderRadius: "100px",
  color: colors.brandBlue600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  padding: "8px 12px",
}));

const styles = (expand: boolean) =>
  makeStyles(() => ({
    wrapper: {
      padding: "0 16px",
    },
    headerWrapper: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 20,
    },
    taskTitle: {
      font: "700 16px/24px Manrope",
      color: "#465869",
    },
    wrapperSection: {
      borderBottom: "1px solid #E0E2E7",
      paddingBottom: `${expand ? "18px" : "12px"}`,
      marginTop: expand ? 12 : 5,
    },
    expandIcon: {
      fontSize: 24,
      cursor: "pointer",
    },
    tag: {
      backgroundColor: "#EDF5FB",
      borderRadius: 4,
      padding: 4,
      font: "600 12px/20px Manrope",
      color: "#308CDB",
    },
    m16: {
      marginTop: "0.5rem",
      marginBottom: "1rem",
    },
    sendToSISTRS: {
      "&:not(:last-child)": {
        marginRight: "6px",
      },
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    loadingSISTRS: {
      color: "#475467",
    },
  }));

export default styles;
